import { createClient } from '@supabase/supabase-js';

// Get Supabase credentials from environment variables
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file for REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY'
  );
}

/**
 * Shared Supabase Client Instance
 *
 * This is the single source of truth for Supabase authentication and database access.
 * Import this client throughout the app to ensure consistent session state.
 *
 * Configuration:
 * - autoRefreshToken: Automatically refresh auth tokens before expiry
 * - persistSession: Save session to localStorage for persistence across page loads
 * - detectSessionInUrl: Automatically detect and handle auth callbacks (magic links)
 * - storageKey: Custom key for localStorage to avoid conflicts with other apps
 */
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: window.localStorage,
    storageKey: 'community_services_auth',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  }
});

// Export client as default for convenience
export default supabase;
